import(/* webpackMode: "eager" */ "/app/src/app/[commerce]/[locale]/[currency]/template.tsx");
